<template>
    <div class="tw:bg-sky-50 tw:border tw:border-sky-200 tw:rounded-2xl tw:p-4">
        <div class="tw:flex tw:gap-3">
            <svg class="tw:w-5 tw:h-5 tw:text-sky-500 tw:flex-shrink-0 tw:mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
            </svg>
            <div class="tw:flex tw:flex-col tw:gap-3">
                <p class="tw:text-sm tw:text-gray-700" v-html="$t(esMembresia ? 'eventos.abonado_vinculado_cuenta_membresia' : 'eventos.abonado_vinculado_cuenta_abono', { email: boundEmailEscaped, simpatizante: textoSimpatizanteEscaped })"></p>
                <p class="tw:text-sm tw:text-gray-600" v-html="$t('eventos.acceder_cuenta')"></p>
                <p class="tw:text-sm tw:text-gray-600" v-html="$t('eventos.problema_contacto', { email: contactEmailEscaped })"></p>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import store from '@/store';

    const props = defineProps({
        boundEmail: {
            type: String,
            default: ''
        },
        contactEmail: {
            type: String,
            default: 'abonados@albacetebalompie.com'
        },
        entitlementType: {
            type: String,
            default: 'abono'
        }
    });

    const esMembresia = computed(() => props.entitlementType === 'membresia');

    const teatro = computed(() => store.getters.getTeatro || {});
    const textoSimpatizante = computed(() => teatro.value.texto_simpatizante || '');

    // Los valores interpolados entran en cadenas renderizadas con v-html
    // (el email también dentro de un href="mailto:{email}"). Escapamos TODO
    // el HTML (incluidas comillas) por contexto texto/href: el markup de los
    // strings de traducción es estático, los params van siempre escapados.
    const escapeHtml = value => String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const boundEmailEscaped = computed(() => escapeHtml(props.boundEmail));
    const contactEmailEscaped = computed(() => escapeHtml(props.contactEmail));
    const textoSimpatizanteEscaped = computed(() => escapeHtml(textoSimpatizante.value));
</script>
